import React, { useState, useEffect } from 'react';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import { preventInvalidKeys, blurOnWheel, preventInvalidPaste } from 'src/reusable/inputSettings';
import { getReport, getDetails, changeStatus, saveSwa, EditSwa } from 'src/request/Reports';
import { ReportLayout } from './components';

const SwaV2 = (props) => {
  const [swaData, setSwaData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [file, setFile] = useState([]);
  const [fileName, setFileName] = useState([]);
  const [cond, setCond] = useState('Add');
  const [reportLogId, setReportLogId] = useState(-1);
  const [remove, setRemove] = useState([]);
  const [fileLength, setFileLength] = useState(0);
  const [status, setStatus] = useState(0);
  const [errors, setErrors] = useState([]);
  const [progressReport, setProgressReport] = useState([
    {
      report_id: -1,
      prepared_by: '',
      billing_percentage: '',
      remarks: '',
    },
  ]);
  const [modal, setModal] = useState(false);

  useEffect(() => {
    getSwa(status);
  }, []);

  const getSwa = (selectedStatus) => {
    setIsLoading(true);
    getReport(props.id, 'swa', selectedStatus)
      .then((res) => {
        if (res.data?.status == 1) {
          setSwaData(res.data.response || []);
        } else {
          Swal.fire({
            icon: 'error',
            title: res.data?.response || 'Error',
            text: res.data?.description || 'Failed to fetch SWA reports',
            confirmButtonColor: '#23303D',
          });
        }
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const validate = () => {
    const newErrors = [];
    progressReport.forEach((data, index) => {
      let error = {};
      if (!data.prepared_by?.trim()) {
        error.prepared_by = 'Prepared By is required';
      }
      if (data.billing_percentage === '' || data.billing_percentage === null || data.billing_percentage === undefined) {
        error.billing_percentage = 'Billing Percentage is required';
      } else if (isNaN(data.billing_percentage) || Number(data.billing_percentage) < 0 || Number(data.billing_percentage) > 100) {
        error.billing_percentage = 'Billing Percentage must be between 0 and 100';
      }
      newErrors[index] = error;
    });
    setErrors(newErrors);
    return newErrors.every((error) => Object.keys(error).length === 0);
  };

  const save = () => {
    if (validate()) {
      saveSwa(file, progressReport, props.id).then((res) => {
        if (res.data?.status == 1) {
          Swal.fire({
            icon: 'success',
            title: 'Your work has been saved',
            showConfirmButton: false,
            timer: 1500,
          });
          setModal(false);
          getSwa(status);
        } else {
          Swal.fire({
            icon: 'error',
            title: res.data?.response || 'Error',
            text: res.data?.description || 'Failed to save SWA report',
            confirmButtonColor: '#23303D',
          });
        }
      });
    }
  };

  const edit = () => {
    if (validate()) {
      EditSwa(file, progressReport, props.id, remove).then((res) => {
        if (res.data?.status == 1) {
          Swal.fire({
            icon: 'success',
            title: 'Your work has been updated',
            showConfirmButton: false,
            timer: 1500,
          });
          setModal(false);
          getSwa(status);
        } else {
          Swal.fire({
            icon: 'error',
            title: res.data?.response || 'Error',
            text: res.data?.description || 'Failed to update SWA report',
            confirmButtonColor: '#23303D',
          });
        }
      });
    }
  };

  const getReportById = (selectedReportLogId, mode = 'View') => {
    setReportLogId(selectedReportLogId);
    setCond(mode);
    setErrors([]);
    getDetails('swa', selectedReportLogId).then((res) => {
      if (res.data?.status == 1) {
        setProgressReport([
          {
            report_id: res.data.response.report_id,
            billing_percentage: res.data.response.billing_percentage,
            prepared_by: res.data.response.prepared_by,
            remarks: res.data.response.remarks,
          },
        ]);

        const existingFiles = (res.data.response.files || []).map((f) => ({
          name: f.name,
          link: f.link,
          isExisting: true,
        }));
        setFileName(existingFiles);
        setFileLength(existingFiles.length);
        setFile([]);
        setRemove([]);
        setModal(true);
      } else {
        Swal.fire({
          icon: 'error',
          title: res.data?.response || 'Error',
          text: res.data?.description || 'Failed to fetch report details',
          confirmButtonColor: '#23303D',
        });
      }
    });
  };

  const AddNew = () => {
    setFile([]);
    setFileName([]);
    setRemove([]);
    setCond('Add');
    setErrors([]);
    setProgressReport([
      {
        report_id: -1,
        prepared_by: '',
        billing_percentage: '',
        remarks: '',
      },
    ]);
    setModal(true);
  };

  const prepareChange = (e, Index) => {
    let arr = [...progressReport];
    arr[Index].prepared_by = e.target.value;
    setProgressReport(arr);
  };

  const percentageChange = (e, Index) => {
    let arr = [...progressReport];
    arr[Index].billing_percentage = e.target.value;
    setProgressReport(arr);
  };

  const textareaChange = (e, Index) => {
    let arr = [...progressReport];
    arr[Index].remarks = e.target.value;
    setProgressReport(arr);
  };

  const handleUploadFiles = (e) => {
    const selectedFiles = Array.from(e.target.files);
    const newFiles = [...file, ...selectedFiles];
    setFile(newFiles);

    const newDisplayList = selectedFiles.map((f) => ({
      name: f.name,
      link: '',
      isExisting: false,
      fileRef: f,
    }));
    setFileName([...fileName, ...newDisplayList]);
    e.target.value = '';
  };

  const handleRemoveFile = (item, Index) => {
    let arr = [...fileName];
    let arrFile = [...file];
    let arrRemove = [...remove];

    arr.splice(Index, 1);

    if (item.isExisting) {
      arrRemove.push(item.name);
    } else {
      const fileIndex = arrFile.findIndex((f) => f === item.fileRef || f.name === item.name);
      if (fileIndex !== -1) {
        arrFile.splice(fileIndex, 1);
      }
    }

    setFileName(arr);
    setFile(arrFile);
    setRemove(arrRemove);
  };

  const changeStatusReport = (selectedReportLogId, method) => {
    const isArchiving = method === 'DELETE';
    Swal.fire({
      icon: 'question',
      title: `<span style='color:#B42A19;'>${isArchiving ? 'Archive Report?' : 'Restore Report?'}</span>`,
      html: `<p style='font-weight:600;'>Are you sure you want to ${isArchiving ? 'archive' : 'restore'} this report?</p>`,
      showCancelButton: true,
      confirmButtonColor: '#23303D',
      cancelButtonColor: '#B42A19',
      confirmButtonText: isArchiving ? 'Yes, archive' : 'Yes, restore',
    }).then((result) => {
      if (result.isConfirmed) {
        changeStatus(selectedReportLogId, method).then((res) => {
          if (res.data?.status == 1) {
            Swal.fire({
              icon: 'success',
              title: isArchiving ? 'Report has been archived' : 'Report has been restored',
              showConfirmButton: false,
              timer: 1500,
            });
            getSwa(status);
          } else {
            Swal.fire({
              icon: 'error',
              title: res.data?.response || 'Error',
              text: res.data?.description || 'Failed to update report status',
              confirmButtonColor: '#23303D',
            });
          }
        });
      }
    });
  };

  return (
    <ReportLayout
      title="Statement of Work Accomplished"
      addButtonLabel="Add New SWA"
      onAddNew={AddNew}
      searchTerm={searchTerm}
      onSearchChange={setSearchTerm}
      searchPlaceholder="Search SWA by date or author..."
      statusFilter={status}
      onStatusFilterChange={(val) => {
        setStatus(val);
        getSwa(val);
      }}
      columns={[
        { key: 'date', label: 'Date' },
        { key: 'submitted', label: 'Submitted By' },
        { key: 'last_modified', label: 'Last Modified', className: 'text-aimhi-textlight-muted' },
      ]}
      data={swaData}
      isLoading={isLoading}
      emptyMessage="No SWA reports found"
      emptySubMessage={
        searchTerm
          ? 'Try clearing your search query'
          : status === 0
            ? 'Create your first Statement of Work Accomplished to get started'
            : 'No archived reports available'
      }
      onView={(report) => getReportById(report.report_log_id, 'View')}
      onEdit={(report) => getReportById(report.report_log_id, 'Edit')}
      onArchive={(report) => changeStatusReport(report.report_log_id, 'DELETE')}
      onRestore={(report) => changeStatusReport(report.report_log_id, 'PUT')}
      isModalOpen={modal}
      onCloseModal={() => {
        setModal(false);
        setErrors([]);
      }}
      modalMode={cond}
      modalTitle={
        cond === 'Add'
          ? 'New Statement of Work Accomplished'
          : cond === 'Edit'
            ? 'Edit Statement of Work Accomplished'
            : 'Statement of Work Accomplished Details'
      }
      modalSubtitle={
        cond === 'View'
          ? 'Review recorded work details, billing percentage, and attachments.'
          : 'Fill in the progress billing information and optional attachments.'
      }
      renderModalContent={() => (
        <div className="overflow-x-auto border border-gray-200 rounded-lg mb-4">
          <table className="w-full text-left border-collapse">
            <thead>
              <tr className="bg-aimhi-light border-b border-gray-200 text-[11px] font-semibold text-aimhi-textlight-neutral uppercase">
                <th className="py-2.5 px-3 min-w-[200px]">
                  Prepared By <span className="text-aimhi-danger">*</span>
                </th>
                <th className="py-2.5 px-3 w-44">
                  Progress Billing % <span className="text-aimhi-danger">*</span>
                </th>
                <th className="py-2.5 px-3 min-w-[220px]">Remarks</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-100 text-xs">
              {progressReport.map((data, Index) => (
                <tr key={Index} className="hover:bg-gray-50/50">
                  <td className="py-2 px-3 align-top">
                    <input
                      type="text"
                      placeholder="e.g. John Doe"
                      value={data.prepared_by || ''}
                      disabled={cond === 'View'}
                      onChange={(e) => prepareChange(e, Index)}
                      className={`w-full px-2.5 py-1.5 text-xs rounded-md border ${errors[Index]?.prepared_by ? 'border-aimhi-danger' : 'border-gray-300'
                        } bg-white text-aimhi-textlight-neutral placeholder:text-gray-400 focus:outline-none focus:ring-2 focus:ring-aimhi-info/20 focus:border-aimhi-info disabled:bg-gray-100 disabled:text-gray-500`}
                    />
                    {errors[Index]?.prepared_by && (
                      <span className="text-[11px] text-aimhi-danger mt-1 block">
                        {errors[Index].prepared_by}
                      </span>
                    )}
                  </td>
                  <td className="py-2 px-3 align-top">
                    <input
                      type="number"
                      placeholder="0"
                      min="0"
                      max="100"
                      step="0.01"
                      value={data.billing_percentage ?? ''}
                      disabled={cond === 'View'}
                      onKeyDown={preventInvalidKeys}
                      onWheel={blurOnWheel}
                      onPaste={preventInvalidPaste}
                      onChange={(e) => percentageChange(e, Index)}
                      className={`w-full px-2.5 py-1.5 text-xs rounded-md border ${errors[Index]?.billing_percentage ? 'border-aimhi-danger' : 'border-gray-300'
                        } bg-white text-aimhi-textlight-neutral placeholder:text-gray-400 focus:outline-none focus:ring-2 focus:ring-aimhi-info/20 focus:border-aimhi-info disabled:bg-gray-100 disabled:text-gray-500`}
                    />
                    {errors[Index]?.billing_percentage && (
                      <span className="text-[11px] text-aimhi-danger mt-1 block">
                        {errors[Index].billing_percentage}
                      </span>
                    )}
                  </td>
                  <td className="py-2 px-3 align-top">
                    <textarea
                      rows={2}
                      placeholder="Optional remarks..."
                      value={data.remarks || ''}
                      disabled={cond === 'View'}
                      onChange={(e) => textareaChange(e, Index)}
                      className="w-full px-2.5 py-1.5 text-xs rounded-md border border-gray-300 bg-white text-aimhi-textlight-neutral placeholder:text-gray-400 focus:outline-none focus:ring-2 focus:ring-aimhi-info/20 focus:border-aimhi-info disabled:bg-gray-100 disabled:text-gray-500"
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
      enableAttachments
      attachments={fileName}
      onUploadFiles={handleUploadFiles}
      onRemoveAttachment={handleRemoveFile}
      acceptedFileTypes=".xlsx,.xls,.csv,.pdf,.png,.jpg,.jpeg"
      attachmentFileInputId="swa-file-input"
      onSubmit={save}
      onUpdate={edit}
    />
  );
};

export default SwaV2;
